import { BrowserRouter } from 'react-router-dom'
import './index.css'
import { createRoot } from 'react-dom/client'
import { Provider, useSelector } from 'react-redux'
import { initializeApp } from 'firebase/app'
import * as Sentry from '@sentry/react'
import { BrowserClient } from '@sentry/browser'
// import { getAnalytics } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'

import Store from './store'
import Core from './core/components/core'
import { deviceDetect } from 'react-device-detect'
import AgoraRTC from 'agora-rtc-react'

import { register } from './workbox/serviceWorker'
import { initSync } from './db/dbSync'
import { ProceduresProvider } from './custom/Examination/examination-utils/ProceduresContext'
import { initializeWebSocket } from './custom/lib/web-socket-manager'

// Initialize sync system after store creation
initSync()

// Register the service worker after the app has loaded
if (process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    register()
  })
}

// Sentry
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserClient(), new Sentry.addIntegration(Sentry.breadcrumbsIntegration({ console: false }))],
  tracesSampleRate: 1.0,
  sendDefaultPii: true
})

// Firebase Authentication & Analytics
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MSG_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
}

const firebaseApp = initializeApp(firebaseConfig)
const firebaseAuth = getAuth(firebaseApp)
// const firebaseAnalytics = getAnalytics(firebaseApp)

firebaseAuth.useDeviceLanguage()

AgoraRTC.setLogLevel(4)

// Initialize App
const App = () => {
  const state = useSelector((state) => state.core)
  return <Core state={state} />
}

const container = document.getElementById('root')
const root = createRoot(container)

// Initialize WebSocket connection and listeners
initializeWebSocket()

root.render(
  <Provider store={Store}>
    <BrowserRouter>
      <div
        style={{
          position: 'relative',
          minHeight: '100vh',
          width: '100%',
          background: deviceDetect().isMobile ? '' : 'white'
        }}
      >
        <ProceduresProvider>
          <App />
        </ProceduresProvider>
      </div>
    </BrowserRouter>
  </Provider>
)
export { firebaseAuth }
